import { defineAsyncComponent } from 'vue'
export default {
  basic: defineAsyncComponent(() => import("/vercel/path0/layouts/basic.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m))
}